export default function home_news() {
	
  $('.news-list .item-readmore a').each(function(){
    $(this).magnificPopup({
      items: {
        src: $(this).attr('href'),
        type: 'inline'
      }
    });
  });
	
}